export default {
  windowScrollTop () {
    return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  },
  preloadImages (imgSrcs) {
    return new Promise((resolve) => {
      let images = []
      let promises = []

      for (var i = 0; i < imgSrcs.length; i++) {
        promises[i] = new Promise(resolve => {
          images[i] = new Image()
          images[i].addEventListener('load', function handler () {
            this.removeEventListener('load', handler)
            resolve()
          })
          images[i].src = imgSrcs[i]
        })
      }

      Promise.all(promises).then(() => {
        resolve(images)
      })
    })
  },
  urlEncodeData (data) {
    var buffer = []
    for (let key in data) {
      if (!data.hasOwnProperty(key)) continue
      let encodedKey = encodeURIComponent(key)
      let encodedValue = encodeURIComponent(data[key])
      buffer.push(encodedKey + '=' + encodedValue)
    }
    buffer = buffer.join('&')
    return buffer
  },
  cleanQuery (query) {
    if (!query) return {}
    return query.split('&').reduce(function (obj, curr, i, arr) {
      let item = curr.split('=')
      obj[decodeURIComponent(item[0])] = decodeURIComponent(item[1])
      return obj
    }, {})
  },
  formatDate (date, short) {
    let dateObj = new Date(date)

    if (!(dateObj instanceof Date && isFinite(dateObj))) return ''

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    let shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let month = short ? shortMonths[dateObj.getMonth()] : months[dateObj.getMonth()]
    let dateStr = month + ' ' + dateObj.getDate() + ', ' + dateObj.getFullYear()
    return dateStr
  },
  numericalDate: function (dateInput) {
    let date = new Date(dateInput)
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    if (day < 10) day = '0' + day
    if (month < 10) month = '0' + month
    return {
      day: day,
      month: month,
      year: year
    }
  },
  savePercent: function (yearlyPrice, monthlyPrice, bearType) {
    let large = parseFloat(yearlyPrice)
    let small = parseFloat(monthlyPrice)
    let result = Math.abs(small * 12 - large) / (small * 12)
    if (bearType === 'kodiak') {
      result = Math.abs(small * 24 - large) / (small * 24)
    }
    return Math.round(result * 100)
  },
  macOsVersion: function () {
    let os = 'Mac OS X '
    let ua = navigator.userAgent
    let firefox = ua.toLowerCase().indexOf('firefox') > -1
    let start = ua.indexOf(os) + os.length
    let end = firefox ? ua.substring(start).indexOf(';') : ua.substring(start).indexOf(')')

    let version = ua.substring(start, start + end)

    version = firefox ? version.split('.')[1] : version.split('_')[1]

    return version > 9 ? 3 : 2
  },
  datePlusSevenDays: function () {
    return new Date((new Date()).getTime() + 7 * 24 * 60 * 60 * 1000)
  },
  datePlusMonth: function () {
    let dateObj = new Date()
    return dateObj.setMonth(dateObj.getMonth() + 1)
  }
}



// WEBPACK FOOTER //
// ./src/services/services.js